import { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  clone,
  pullAt,
  findLastIndex,
  isArray,
} from 'lodash';
import API from '../../api';
import TableMessages from '../VibeTable/Tables/TableMessages';
import withRouter from '../../wrappers/withRouter';
import {
  setDisplay,
} from '../../actions/Display/DisplayActions';
import './MessagesUnassigned.scss';

class MessagesUnassigned extends PureComponent {
  constructor(props) {
    super(props);

    const {
      selected,
    } = props;

    this.state = {
      selected,
    };
  }

  componentDidUpdate(prevProps) {
    const {
      selected,
    } = this.props;

    const {
      selected: prevSelected,
    } = prevProps;

    if (JSON.stringify(selected) !== JSON.stringify(prevSelected)) {
      this.setState({
        selected,
      });
    }
  }

  showDisplayPlayer = async (e, messages) => {
    const {
      setDisplay,
    } = this.props;

    e.preventDefault();
    e.stopPropagation();

    setDisplay({
      show: true,
      messages,
      isLoop: false,
    });
  };

  onAdd = (items) => {
    const {
      onChange,
    } = this.props;

    if (!isArray(items)) {
      items = [items];
    }

    const newItems = items.map((item) => {
      const newItem = clone(item);

      // remove the row ID to give it a unique identifier
      delete newItem._rowId;
      return newItem;
    });

    this.setState((state) => {
      const messages = [
        ...state.selected,
        ...newItems,
      ];

      onChange(messages);

      return {
        selected: messages,
      };
    });
  };

  onRemove = (item) => {
    const {
      onChange,
    } = this.props;

    this.setState((state) => {
      const {
        selected,
      } = state;

      const lastIndex = findLastIndex(selected, { _id: item._id });

      // only remove one message in case there are duplicates
      pullAt(selected, lastIndex);
      onChange(selected);

      return {
        selected,
      };
    });

    // needed because the third panel table isn't re-rendered on a prop/state change
    document.dispatchEvent(new Event('onRenderTable'));
    document.dispatchEvent(new Event('onUpdateTableAssignedMessages'));
  };

  render() {
    const {
      columns = [],
      customToolbar,
      filters,
      onChange,
    } = this.props;

    const {
      selected,
    } = this.state;

    return (
      <div className="MessagesUnassigned">
        <div className="title-container">
          <div className="title">
            Available Messages
          </div>

          {customToolbar}
        </div>

        <div className="messages-container">
          <TableMessages
            columns={columns.length > 0 ? [
              'Add/Remove Quantity',
              ...columns,
             ] : [
              'Add/Remove Quantity',
              'Message Name',
              'Company',
              'Last Updated',
              'Requester',
              'Start Date',
              'End Date',
              'Duration',
              'Script',
              'Tags',
              '...',
            ]}
            fetch={API.Message.list}
            filters={filters}
            defaultSortBy={{
              label: 'Last Updated',
              attr: 'modifiedDate',
              direction: 'desc',
            }}
            paginator
            paginatorProps={{
              label: 'Messages',
              urlPaging: false,
              urlFilters: false,
            }}
            menuItems={(row) => {
              const isAd = row.messageType === 'ad'
                || row.messageType === 'ext-ad';

              return [{
                name: 'Archive',
                userCan: isAd
                  ? 'advertisement.delete'
                  : 'message.delete',
              }];
            }}
            available
            highlight={selected}
            onAdd={this.onAdd}
            onRemove={this.onRemove}
            onChange={onChange}
            showDisplayPlayer={this.showDisplayPlayer}
          />
        </div>
      </div>
    );
  }
}

MessagesUnassigned.propTypes = {
  selected: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
    messageType: PropTypes.string,
    url: PropTypes.string,
    active: PropTypes.bool,
  })),
  /** Filters for the fetch method */
  filters: PropTypes.oneOfType([
    PropTypes.object,
  ]),
  /** Custom toolbar */
  customToolbar: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /** When the messages are changed */
  onChange: PropTypes.func,
};

MessagesUnassigned.defaultProps = {
  filters: null,
  selected: [],
  customToolbar: null,
  onChange: () => {},
};

const mapDispatchToProps = {
  setDisplay,
};

export default withRouter(connect(null, mapDispatchToProps)(MessagesUnassigned));
